
import { SPACING } from "../../stack-shared/constants/app.constants";

interface IContentHeader {
    title: string;
}

export const ContentHeader = (props: IContentHeader) => {


    return (
        <h2 style={{ marginBottom: SPACING.SM }}>{props.title}</h2>
    )

}